var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data && _vm.data.length)?_c('div',{staticClass:"cn-rich-advantages-list"},_vm._l((_vm.data),function(item,i){return _c('RichAdvantages',{key:i,attrs:{"data":item,"inverted":(i + 1) % 2 === 0}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }